import { render, staticRenderFns } from "./SamlError.vue?vue&type=template&id=2b040148&"
import script from "./SamlError.vue?vue&type=script&lang=js&"
export * from "./SamlError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports